import axios from "axios";
//Axios is a popular JavaScript library used for making HTTP requests from browsers 
//import axios from "axios"; you're assigning the default export of the "axios" module to a variable named axios
import queryString from "query-string";
//queryString: This is the name of the variable we're assigning the imported functionality to. 
//In this case, we're importing something from the "query-string" module and assigning it to a variable named queryString.
//"query-string" is a library in JavaScript used for parsing and formatting URL query strings. URL query strings are the part
// of a URL that comes after the ? character and contains key-value pairs (e.g., ?key1=value1&key2=value2). This library provides
// functions to parse these query strings into JavaScript objects and vice versa.
const baseURL = "https://moonflix-api.vercel.app/api/v1/";

const baseClient = axios.create({
    baseURL,
    paramsSerializer: params => queryString.stringify(params),
    headers: {

        "Content-Type": "application/json"
    }
});

baseClient.interceptors.request.use(config => {
    const token = localStorage.getItem("actkn");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

baseClient.interceptors.response.use(
    response => response.data,
    error => Promise.reject(error.response.data)
);

const mediaEndpoints = {
    list: ({ mediaType, mediaCategory, page }) => `${mediaType}/${mediaCategory}?page=${page}`,
    detail: ({ mediaType, mediaId }) => `${mediaType}/detail/${mediaId}`,
    search: ({ mediaType, query, page }) => `${mediaType}/search?query=${query}&page=${page}`
};

const mediaApi = {
    getList: async ({ mediaType, mediaCategory, page }) => {
        try {
            const response = await baseClient.get(mediaEndpoints.list({ mediaType, mediaCategory, page }));
            console.log(response)
            return { response };

            
        } catch (err) {
            return { err };
        }
    },
    getDetail: async ({ mediaType, mediaId }) => {
        try {
            const response = await baseClient.get(mediaEndpoints.detail({ mediaType, mediaId }));
            console.log(response)
            return { response };
        } catch (err) {
            return { err };
        }
    },
    search: async ({ mediaType, query, page }) => {
        try {
            const response = await baseClient.get(mediaEndpoints.search({ mediaType, query, page }));
            console.log(response)
            return { response };
        } catch (err) {
            return { err };
        }
    },
    getVideos: async ({ mediaType, mediaId }) => { // Define getVideos function
        try {
            const response = await baseClient.get(`videos/${mediaType}/${mediaId}`);
            return { response };
        } catch (err) {
            return { err };
        }
    }
};

export default mediaApi;
